// AuthGuard.js
import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import UserSignInModal from "../components/user/UserSignInModal";

export default function AuthGuard({ children }) {
  const user = useSelector(state => state.user);
  const location = useLocation();

  const [showModal, setShowModal] = useState(false);
  const [userModalOptions, setUserModalOptions] = useState({});

  useEffect(() => {
    if (!user.isSignedIn) {
      setUserModalOptions({
        onSuccess: () => setShowModal(false)
      });
      setShowModal(true);
    }
  }, [user]);

  if (!user.isSignedIn) {
    return (
      <>
        <UserSignInModal
          show={showModal}
          options={userModalOptions}
          onClose={() => setShowModal(false)}
        />
      </>
    );
  }

  return <>{children}</>;
}
